
const durationTime=async(file)=>{
    let res=null;
 const resultTime=getDuration(file).then((result)=>{
 
 return result.sure
 })
 const dt=await resultTime.then((respons)=>{
     console.log(respons)
     return respons
     
 })
     return dt
     
 }
 
 
 
 const getDuration=(file)=>{
     
     const reader = new FileReader();
     
      const data=
      new Promise((resolve)=>{
         
         reader.onload = (f) => {
             console.log("ses dosyası hesaplanıyor")
            const audiod = new Audio(f.target.result);
             
             
            
             
          const duraitonTime=  setInterval(() => {
                const duration = audiod.duration;
              
                if(duration!="NaN")
                {
                   
                    resolve({sure:duration})
                    clearInterval(duraitonTime);
                   
                }
                
            }, 1000)
            
         
         
 
          }
          reader.readAsDataURL(file);
     })
     console.log("pekidata", data)
     return data
 }
 
 export {
     getDuration,
     durationTime,
 }